import { useSelector } from "react-redux";
import { selectListItems } from "../../../../../../redux/library/selector";
import { AccordionContainer } from "../../../../../../common/components/accordion/accordion.module";
import { InputContainer } from "../../../../../../common/components/form/input/containers/input.container";

export default function OnBoardingFounderDetailsComponent ({handleInnerbasicFormChange,handleFormChange, subscriptionDetails}: any) {
    const libraryData = useSelector(selectListItems)
    return (
      <>
        <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
        <InputContainer

label="First Name of Founder"
name="First Name of Founder"
onValueChange={(event: any) => {
  handleFormChange({
    value: event.target.value,
    field: 'FounderDetails.FirstNameOfFounder_CEO',
    data: subscriptionDetails?.FounderDetails
  });
}}
type="text"
value={subscriptionDetails?.FounderDetails?.FirstNameOfFounder_CEO}
/>
  <InputContainer
  
  label="Last Name of Founder"
  name="Last Name of Founder"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'FounderDetails.LastNameOfFounder_CEO',
      data: subscriptionDetails?.FounderDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.FounderDetails?.LastNameOfFounder_CEO}
  />
  
  <InputContainer
  
  label="Email Address of Founder"
  name="Email Address of Founder"
  onValueChange={(event: any) => {
    handleFormChange({
      value: event.target.value,
      field: 'FounderDetails.EmailOfFounder_CEO',
      data: subscriptionDetails?.FounderDetails
    });
  }}
  type="text"
  value={subscriptionDetails?.FounderDetails?.EmailOfFounder_CEO}
  />
   </div>
  }
  expandedPanel="Details of Founder"
  headerTitle="Details of Founder(CEO)"
/>
</>
  )
}